(() => {
  const COLOR_WORDS = ['color','colour','cor','couleur','farbe','colore'];
  const colorMap = {
    black:'#171716',white:'#f4f3ef',ivory:'#efe9dd',cream:'#eadfc9',beige:'#d5c5a9',khaki:'#9a9277',tan:'#b78c67',camel:'#ae835e',
    brown:'#63432f',chocolate:'#3f291f',coffee:'#5b4031',grey:'#bebfbd',gray:'#bebfbd',charcoal:'#4d4f4d',blue:'#5d7898',navy:'#273142',denim:'#6b8098',
    red:'#9a2928',wine:'#5c2430',burgundy:'#5a2632',pink:'#ddb2bb',blush:'#e4c2c2',green:'#66765e',olive:'#74764f',sage:'#9da88f',yellow:'#d9bb57',butter:'#e8d99c',
    orange:'#c87945',purple:'#88709a',lilac:'#c3b1d0',silver:'#bfc0c0',gold:'#b09259'
  };
  const clean = value => String(value || '').trim().toLowerCase().replace(/[:：]/g,'');
  const isColor = value => COLOR_WORDS.some(word => clean(value) === word || clean(value).includes(word));
  const colorFor = value => {
    const normalized = clean(value);
    for (const [token,hex] of Object.entries(colorMap)) if (normalized.includes(token)) return hex;
    return '#dededb';
  };
  function config() {
    const nodes = document.querySelectorAll('[data-reevys-pdp-config]');
    if (!nodes.length) return null;
    try { return JSON.parse(nodes[nodes.length - 1].textContent); } catch(e) { return null; }
  }
  function labelOf(option) {
    const node = [...option.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    return clean(node?.textContent || '');
  }
  function enhance() {
    const cfg = config();
    if (!cfg) return;
    document.querySelectorAll('main[data-template*="product"] [data-testid="variant-option-single"]').forEach(option => {
      if (option.dataset.reevysSingleEnhanced === 'true') return;
      const label = labelOf(option);
      if (!isColor(label)) return;
      const value = option.querySelector('.variant-option__swatch-value')?.textContent?.trim();
      if (!value) return;
      option.dataset.reevysSingleEnhanced = 'true';
      option.classList.add('reevys-single-color-option');
      const rawCode = cfg.styleCode || cfg.variants?.find(v => String(v.id) === String(cfg.currentVariantId))?.sku || cfg.variants?.[0]?.sku || '';
      const displayCode = rawCode ? (String(rawCode).startsWith('#') ? String(rawCode) : `#${rawCode}`) : '';
      option.innerHTML = '';
      const ui = document.createElement('div');
      ui.className = 'reevys-pdp-color-ui';
      const head = document.createElement('div');
      head.className = 'reevys-pdp-color-head';
      head.innerHTML = `<span>Color <span class="reevys-pdp-color-value"></span></span><span class="reevys-pdp-style-code"></span>`;
      head.querySelector('.reevys-pdp-color-value').textContent = value;
      const code = head.querySelector('.reevys-pdp-style-code');
      code.textContent = displayCode;
      code.hidden = !displayCode;
      const swatches = document.createElement('div');
      swatches.className = 'reevys-pdp-color-swatches';
      const swatch = document.createElement('button');
      swatch.type = 'button';
      swatch.className = 'reevys-pdp-swatch';
      swatch.disabled = true;
      swatch.setAttribute('aria-label', value);
      swatch.setAttribute('aria-pressed','true');
      swatch.style.setProperty('--reevys-swatch-color', colorFor(value));
      swatches.appendChild(swatch);
      ui.append(head, swatches);
      option.appendChild(ui);
    });
  }
  const observer = new MutationObserver(() => requestAnimationFrame(enhance));
  observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('DOMContentLoaded',enhance,{once:true});
  document.addEventListener('shopify:section:load',enhance);
  enhance();
})();
